import styles from './UseCaseCard.module.css';

interface UseCaseCardProps {
  tag: string;
  title: string;
  description: string;
}

export function UseCaseCard({ tag, title, description }: UseCaseCardProps) {
  return (
    <div className={styles.card}>
      <span className={styles.tag}>{tag}</span>
      <h4 className={styles.title}>{title}</h4>
      <p className={styles.description}>{description}</p>
    </div>
  );
}
